import { Component, Input, OnInit } from '@angular/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { CardComponent } from '../card.component';

@Component({
  selector: 'app-card-empty',
  standalone: true,
  imports: [InlineSVGModule, CardComponent],
  templateUrl: './card-empty.component.html',
  styleUrls: ['./card-empty.component.scss'],
})
export class CardEmptyComponent implements OnInit {
  @Input() text: string;
  @Input() icon: string;
  constructor() {}

  ngOnInit(): void {}
}
